/**
 * The namespace of the i18n/translation keys.
 *
 * @type {string}
 */
export const _TNS = 'deepLinking';


export const PlatformOS = {
    'windows': 'https://apps.microsoft.com/detail/9nqkdpw234zn',
    'macos': 'https://apps.apple.com/in/app/meet-hour-desktop/id6772708872',
    'ios': 'https://apps.apple.com/in/app/meet-hour/id1527001689',
    'android': 'https://play.google.com/store/apps/details?id=go.meethour.io',
    'linux': 'https://repo.meethour.io/download/linux/latest/meet-hour-amd64.deb'
};

